module.exports = __webpack_public_path__ + "static/media/09-08.f7442a48.png";